<div class="container">
    <div class="icon-container">
        <span class="icon"></span>
    </div>
    <span class="title">
        <h2>{{text}}</h2>
    </span>
    <div class="description">
        <!-- <p>
            {{ "LABEL_SURE_ALERT" | translate}}
        </p> -->
        <p>
            {{ "LABEL_THIS_ACTION_ALERT" | translate}}
        </p>
    </div>
    <div class="form-container">
        <span class="label-time">{{ "LABEL_TIME" | translate}}</span>
        <!-- <mat-select [(value)]="selectedHour">
            <mat-option *ngFor="let item of hourValues" [value]="item">
                {{item}}
            </mat-option>
        </mat-select>
        <span class="label-time">:</span>
        <mat-select [(value)]="selectedMinute">
            <mat-option *ngFor="let item of minuteValues" [value]="item">
                {{item}}
            </mat-option>
        </mat-select> -->
        <mat-form-field appearance="fill">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker"   [min]="minDate" [(ngModel)]="selectedDate" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <!-- Hora -->
        <mat-form-field appearance="fill" style="width: 80px;">
            <mat-label>Hora</mat-label>
            <mat-select [(ngModel)]="selectedHour">
                <mat-option *ngFor="let hour of hourValues" [value]="hour">{{ hour }}</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Minuto -->
        <mat-form-field appearance="fill" style="width: 80px;">
            <mat-label>Minuto</mat-label>
            <mat-select [(ngModel)]="selectedMinute">
                <mat-option *ngFor="let minute of minuteValues" [value]="minute">{{ minute }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="buttons-container">
        <button class="no-button" (click)="cancel()" mat-raised-button>{{'DIALOG_BACK_CANCEL' | translate}}</button>
        <button class="ok-button" (click)="pause()" mat-raised-button>{{'PAUSE_ALERT' | translate}}</button>
    </div>
</div>